import { Select } from "@chakra-ui/react";
import styled from "styled-components";

export const AcompanhamentoPropostasContainer = styled.div`
  margin-top: 15px;
  background-color: #f9fbfb;
`;
export const AcompanhamentoPropostasContainerText = styled.div`
  background-color: #404042;
  padding: 15px 0;
  h1 {
    color: #fff;
    font-size: 23px;
    font-weight: 400;
    text-align: center;
  }
`;
export const ContentLoading = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  z-index: 99999;
  background-color: #ffffff;
`;
export const ContentLoadingContent = styled.div`
  width: 100px;
  height: 100px;
  position: relative;
  margin-left: auto;
  margin-right: auto;
  top: 20%;
  background-color: #fff;
`;
export const ContentTablesObs = styled.p`
  font-family: "Akrobat";
  color: #8598ad;
  font-size: 16px;
  text-align: center;
  padding: 20px 0 10px;
  background-color: #f0f4f5;
  letter-spacing: 0.06rem;
  font-weight: 300;
`;
export const ContentFilterSelect = styled.div`
  background-color: #fff;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  padding: 0 10px;
  font-size: 13px;
  margin: 0 10px;
  display: flex;
  align-items: center;

  input {
    border: 0;
    color: #919aae;
  }
  label {
    color: #404042;
    width: 100px;
    height: 40px;
    position: relative;
    font-family: "Akrobat";
    float: left;
    display: flex;
    align-items: center;
    font-size: 16px;
    strong {
      position: relative;
      left: 10px;
      font-size: 20px;
      font-family: "Akrobat ExtraBold";
    }
  }
`;
export const ContentFilterSelectTransparent = styled.div`
  background-color: transparent;
  -webkit-border-radius: 3px;
  -moz-border-radius: 3px;
  border-radius: 3px;
  padding: 0 10px;
  font-size: 13px;
  margin: 0 10px;
  display: flex;
  align-items: center;
  input {
    border: 0;
    color: #919aae;
  }
  label {
    width: 100px;
    height: 40px;
    position: relative;
    font-family: "Akrobat Extrabold";
    float: left;
    display: flex;
    align-items: center;
    color: #404042;
    font-size: 16px;
    strong {
      position: relative;
      left: 10px;
      font-size: 20px;
      font-family: "Akrobat ExtraBold";
    }
  }
`;

export const ComboRadio = styled.div`
  display: flex;
  label {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin: 0 5px;

    .orange {
      &:checked {
        &:after {
          width: 17px;
          height: 17px;
          border-radius: 15px;
          top: -2px;
          left: -1px;
          position: relative;
          background-color: #fdb913;
          content: "";
          display: inline-block;
          visibility: visible;
          border: 2px solid white;
        }
      }
    }

    .green {
      &:checked {
        &:after {
          width: 17px;
          height: 17px;
          border-radius: 15px;
          top: -2px;
          left: -1px;
          position: relative;
          background-color: #59e00a;
          content: "";
          display: inline-block;
          visibility: visible;
          border: 2px solid white;
        }
      }
    }
    .red {
      &:checked {
        &:after {
          width: 17px;
          height: 17px;
          border-radius: 15px;
          top: -2px;
          left: -1px;
          position: relative;
          background-color: #e83d4a;
          content: "";
          display: inline-block;
          visibility: visible;
          border: 2px solid white;
        }
      }
    }
    input {
    }
    p {
      color: #8598ad;
      font-size: 12px;
      text-align: center;
    }
  }
`;
export const ButtonSelect = styled.button`
  background-color: #404042;
  color: #fff;
  border: none;
  border-radius: 5px;
  font-family: "Akrobat";

  padding: 0 13px;
  height: 50px;
  width: 6rem;
`;
export const TablesGrid = styled.div`
  flex-direction: column;
  font-family: "Akrobat";
  margin-top: 15px;
`;
export const ContentFilter = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 0;
`;
export const ContentFilterSelectVendedor = styled.div`
  width: 200px;
  display: flex;
  align-items: center;
  margin-left: 10px;
  margin-right: 10px;
`;
export const SelectBox = styled(Select)`
  font-family: Akrobat SemiBold;
  box-shadow: none !important;
`;
export const ButtonFilter = styled.button`
  background-color: #404042;
  color: #fff;
  width: 6rem;
  border: none;
  border-radius: 5px;
  padding: 0 13px;
`;
export const ContentTables = styled.div`
  min-height: 50vh;

  thead {
    th {
      padding: 10px 20px;
      color: #404042;
      font-size: 14px;
      font-weight: 400;
    }
  }

  tbody {
    tr {
      background-color: #f6f6f6;
      td {
        padding: 0 20px;
        text-align: center;
        font-size: 14px;
        height: 30px;
      }
    }
  }
`;
export const ContentTablesHighlights = styled.div`
  display: flex;
  justify-content: center;
  font-family: "Akrobat";
  margin: 40px 0;
`;
export const ContentTablesItem = styled.div`
  background-color: #404042;
  color: #fff;
  width: 25%;
  height: 60px;
  margin-right: 30px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  font-family: "Akrobat";
  padding: 0 20px;
  border-radius: 5px;
`;
export const ContentTablesLegends = styled.div`
  background-color: #ebebeb;
  color: rgb(61, 61, 61);
  width: 400px;
  height: 60px;
  padding: 0 20px;
  border-radius: 5px;
  display: flex;
  justify-content: space-between;
  position: relative;
  align-items: center;
`;
export const ContentTablesLegendsItem = styled.div`
  width: 120px;
  height: 30px;
  position: relative;
  float: left;
  display: flex;
  margin-right: 10px;
  justify-content: space-around;
  label {
    font-size: 14px;
    font-family: "Akrobat ExtraBold";
    position: relative;
    top: 5px;
  }

  .circle-orange {
    margin-top: 0.3rem;
    width: 22px;
    height: 22px;
    border-radius: 15px;
    border: 2px solid white;
    background-color: orange;
  }

  .circle-green {
    margin-top: 0.3rem;
    width: 22px;
    height: 22px;
    border-radius: 15px;
    border: 2px solid white;
    background-color: green;
  }

  .circle-red {
    margin-top: 0.3rem;
    width: 22px;
    height: 22px;
    border-radius: 15px;
    border: 2px solid white;
    background-color: red;
  }
`;
export const ContentTablesName = styled.p`
  font-size: 20px;
  font-family: "Akrobat";
  position: relative;
  top: 5px;
`;
export const Span = styled.span`
  background-image: url("../images/icon_folder_green.png");
`;
// export const  = styled.div``;
